<app-header></app-header>
<div class="other-Page container">
    <h3>Privacy Policy</h3>
    <p>Based on the laws of protection of personal data Synergati Infotech IN, hereinafter SYNERGATI INFOTECH recognizes
        that the Privacy and Security of your personal information is a human right very important for you, so SYNERGATI
        INFOTECH is committed to safeguard your personal information with the highest levels of legal, technological and
        administrative security. Also, not to sell, rent, share or disclose your personal information to third parties
        for
        purposes that are unlawful or contrary to those of the owner. Accordingly, this</p>

    <h4>What information do we collect?</h4>
    <p>In general your personal data. For the collection and treatment of such information SYNERGATI INFOTECH is
        committed
        and obliged to observe and comply with the principles of lawfulness, consent, information, quality, purpose,
        loyalty, proportionality and responsibility. That is, all the information we request are collected legally
        according
        to the current Data Protection laws, with your consent, collecting only and exclusively the relevant, correct,
        updated and necessary data.</p>

    <h4>When do we collect information?</h4>
    <p>When you request our subscription services through visits to any of our portals wap, web, sms and by telephone,
        when
        we request information to be part of any of our products and services.</p>

    <h4>How do we use or share information?</h4>
    <p>We use the personal information you give to us, to provide you with the products and services that SYNERGATI
        INFOTECH offers and, in order to make a complete delivery of any kind of communication, incentive, prize and /
        or
        benefit acquired through any of our subscription services Via wap, web and sms. In general, we do not share your
        personal information with third parties if they are not our subsidiaries, or a third party duly contracted with
        confidentiality clauses of information and personal data protection. We remind you that in the matter of
        Personal
        Data Protection, you can exercise your rights according to the following:
        Access: You can contact us by electronic way,</p>

    <h4>How to contact us?</h4>
    <p>In case you have any questions or wish to exercise any of your rights mentioned above, you can contact us through
        our Customer Service department by email at the following email:</p>

</div>
<app-footer></app-footer>